import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import React, { FC } from 'react';
import { IProps } from 'types/common';
import { WIDGET_SMALL_HEIGHT } from '../analytics/utils';

interface IWidgetCardProps extends IProps {
	title: string;
}

const WidgetCard: FC<IWidgetCardProps> = ({ title, children }) => (
	<Card
		elevation={4}
		sx={{
			flexGrow: 1,
			display: 'flex',
			flexDirection: 'column'
		}}
	>
		<CardHeader
			sx={{
				pb: 0
			}}
			title={
				<Typography variant="overline" color="text.secondary">
					{title}
				</Typography>
			}
		/>
		<CardContent
			sx={{
				p: 0,
				minHeight: WIDGET_SMALL_HEIGHT,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				flexGrow: 1
			}}
		>
			{children}
		</CardContent>
	</Card>
);

export default WidgetCard;
